import React from "react";
import styled from "styled-components";
import getIconFromId from "utils/getIconFromId";
import { CheckBox, CheckBoxOutlineBlank } from "@material-ui/icons";
import { usePrepareData } from "../../utils/usePrepareData";

const Holder = styled.div`
  display: flex;
  font-size: 14px;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 50px;
  height: auto;
  width: 330px;
  z-index: 9999;
  background-color: #fff;
  left: 0;
`;
const List = styled.div`
  display: flex;
  width: 100%;
  opacity: ${({ checkedOnlyFavs }) => (checkedOnlyFavs ? "0.5" : 1)};
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
`;
const ImgOverlay = styled.div`
  background-color: #ffffff;
  width: 20px;
  height: 30px;
  position: absolute;
  z-index: 99;
  left: -20px;
`;
const ImgHolder = styled.div`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0px;
  z-index: 9;
  left: 40px;
`;
const Img = styled.img`
  background: transparent;
  margin-left: -20px;
  width: 100%;
`;
const TitleBlock = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #f1f1f1;
  align-items: center;
  opacity: ${({ checkedOnlyFavs }) => (checkedOnlyFavs ? "0.5" : 1)};
  cursor: ${({ checkedOnlyFavs }) => (checkedOnlyFavs ? "not-allowed" : "pointer")};
  & > div {
    padding: 15px;
  }
`;
const FlexHolder = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
const FlexHolderCursorPointer = styled(FlexHolder)`
  cursor: pointer;
`;
const StyledCheckbox = styled(CheckBox)`
  font-size: 16px !important;
  margin-right: 5px;
`;
const StyledOutlinedCheckbox = styled(CheckBoxOutlineBlank)`
  font-size: 16px !important;
  margin-right: 5px;
`;
const All = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.primaryColor};
  cursor: ${({ checkedOnlyFavs }) => (checkedOnlyFavs ? "not-allowed" : "pointer")};
`;
const CName = styled.div`
  padding: 12px 15px;
  cursor: ${({ checkedOnlyFavs }) => (checkedOnlyFavs ? "not-allowed" : "pointer")};
  width: calc(100% - 30px);
  &:hover > ${FlexHolder} > ${ImgHolder} > ${ImgOverlay} {
    background-color: #f1f1f1;
  }
  &:hover {
    background-color: #f1f1f1;
  }
`;

function FilterChannelList({
  channels,
  checkedOnlyFavs,
  setCheckedOnlyFavs,
  selectedChannels,
  toggleChannel,
}) {
  const { selectOrDeselectAll, areAllChannelsSelected } = usePrepareData();
  return (
    <Holder>
      { false?
      <TitleBlock>
        <FlexHolderCursorPointer
          title="Nur Ereignisse von Firmenfavoriten anzeigen"
          alt="Nur Ereignisse von Firmenfavoriten anzeigen"
          onClick={() => {
            setCheckedOnlyFavs(!checkedOnlyFavs);
          }}
        >
          {checkedOnlyFavs ? <StyledCheckbox /> : <StyledOutlinedCheckbox />}
          <span>Nur Ereignisse von Firmenfavoriten anzeigen</span>
        </FlexHolderCursorPointer>
      </TitleBlock>
      :null}
      <TitleBlock checkedOnlyFavs={checkedOnlyFavs}>
        <div>Ereignisse filtern:</div>
        <All
          title={`Alle ${areAllChannelsSelected ? "abwählen" : "auswählen"}`}
          alt={`Alle ${areAllChannelsSelected ? "abwählen" : "auswählen"}`}
          onClick={() => (checkedOnlyFavs ? null : selectOrDeselectAll())}
          checkedOnlyFavs={checkedOnlyFavs}
        >
          Alle {areAllChannelsSelected ? "abwählen" : "auswählen"}
        </All>
      </TitleBlock>
      <List checkedOnlyFavs={checkedOnlyFavs}>
        {channels.map((c, index) => {
          const isFound = selectedChannels.includes(c.id);
          return (
            <CName
              title={c.name}
              alt={c.name}
              checkedOnlyFavs={checkedOnlyFavs}
              key={index}
              onClick={() => (checkedOnlyFavs ? null : toggleChannel(c.id))}
            >
              {isFound ? (
                <FlexHolder>
                  <StyledCheckbox />
                  <ImgHolder>
                    <ImgOverlay />
                    <Img
                      style={{
                        filter: `opacity(1) drop-shadow(20px 0px 0px ${
                          c.color.includes("#") ? c.color : `#${c.color}`
                        })`,
                      }}
                      src={getIconFromId(c.icon)}
                      alt="company-img"
                    />
                  </ImgHolder>
                  <span style={{ paddingLeft: "50px" }}>{c.name}</span>
                </FlexHolder>
              ) : (
                <FlexHolder>
                  <StyledOutlinedCheckbox />
                  <ImgHolder>
                    <ImgOverlay />
                    <Img
                      style={{
                        filter: `opacity(1) drop-shadow(20px 0px 0px ${
                          c.color.includes("#") ? c.color : `#${c.color}`
                        })`,
                      }}
                      src={getIconFromId(c.icon)}
                      alt="company-img"
                    />
                  </ImgHolder>
                  <span style={{ paddingLeft: "50px" }}>{c.name}</span>
                </FlexHolder>
              )}
            </CName>
          );
        })}
      </List>
    </Holder>
  );
}

export default FilterChannelList;
